import React, { Component, useState, useEffect } from "react";
import ReactQuill from "react-quill";
import Utils from "../../../../utility";
import { termsPolicyService } from "../../../../services/index";
import { eventConstants } from "../../../../constants";
import Loader from "../../../../common/components/tablesLoader";

const toolbarOptions = ["bold"];

// const [privacyPolicy, setPrivacyPolicy] = useState("");

class EditorPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: "<div contenteditable='false'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</div>",
    };
  }

  // useEffect(() => {
  //   editorPolicy();
  // }, []);

  //  editorPolicy = async () => {

  //     const reqObj = {
  //       text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vulputate metus eu dui lobortis, eget condimentum libero sodales.dunt diam vel justo pretium, in volutpat mauris lobortis. Vivamus efficitur risus nec interdum vulputate.",
  //     };
  //     console.log(" privacy Policy  cc--", reqObj);
  //     const[err, res] = await Utils.parseResponse(
  //       termsPolicyService.termsPolicy(reqObj)
  //     );
  //     console.log(res, "response of privacy")
  //     setPrivacyPolicy(res.privacyAndPolicy)

  // };

  modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
    ],
  };

  formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  render() {
    return (
      <>
        {this.props.isLoading ? (
          <div className="homePageLoader">
            <Loader />
          </div>
        ) : (
          <ReactQuill
            theme="snow"
            modules={this.modules}
            formats={this.formats}
            value={this.props.policy || ""}
            onChange={(value) =>
              this.props.handleEditorChange(value, eventConstants.policy)
            }
          >
            {/* <div  className="my-editing-area" /> */}
          </ReactQuill>
        )}
      </>
    );
  }
}

export default EditorPolicy;
